import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* sendUnmaskingInvitation({ payload: { uuid, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.unmasking.invitations.send, data: { invited_uuid: uuid } });

    onSuccess && onSuccess(data.result);
    yield put(actions.sendUnmaskingInvitationDone(data.result));
  } catch (error) {
    console.log(error);
    yield handleErrors({
      error,
      putErrorData: actions.sendUnmaskingInvitationFailed,
      handledErrors,
      endpoint: api.unmasking.invitations.send.url
    });
  }
}

export const sendUnmaskingInvitationSaga = takeEvery(types.SEND_UNMASKING_INVITATION_REQUEST, sendUnmaskingInvitation);